import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const LABELING_COVERAGE_QUERY_KEY = 'labelingCoverage';

export function useGetLabelingCoverage({ enabled = true }: { enabled?: boolean } = {}) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [LABELING_COVERAGE_QUERY_KEY, { tenantId }],
    queryFn: async () => api.assets.getLabelingCoverage(tenantId),
    select: data => data.data,
    enabled: !!tenantId && enabled,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  });
}
